import Vue from 'vue'
import userObj, {formatPermissions} from "../../user"

export const updateContext = ({state, commit}, info) => {
    // Get permissions for user
    return Vue.prototype.$rest.get("/user/" + info.id + "/permission").then(function (content) {
        let usr = {}//userObj;
        usr.id = info.id;
        usr.name = info.name;
        usr.email = info.email;
        usr.info = info;

        // TODO: Insert permissions
        let permissions = content.data;
        delete permissions.users;
        usr.permissions = formatPermissions(permissions);

        commit("setContext", usr)
    })
};


// WEBPACK FOOTER //
// ./src/store/actions/context.js